// src/hooks/useGoogleMaps.js
// ─────────────────────────────────────────────────────────────────────────────
// Single source of truth for the Google Maps JS SDK loader.
// Import this hook in EVERY component that needs Google Maps or Places.
// NEVER call useJsApiLoader directly in any component — always use this hook.
//
// Usage:
//   import { useGoogleMaps } from '../../hooks/useGoogleMaps';
//   const { isLoaded, loadError } = useGoogleMaps();
// ─────────────────────────────────────────────────────────────────────────────

import { useJsApiLoader } from '@react-google-maps/api';

// ⚠️  Define libraries OUTSIDE the module (never inside a component or hook).
// A new array reference on every render causes the "called again with different
// options" error even when the values are identical.
const GOOGLE_MAPS_LIBRARIES = ['maps', 'places'];  // load both — one request

// const GOOGLE_MAPS_OPTIONS = {
//   id:               'google-maps-shared',           // single id across entire app
//   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
//                     || 'AIzaSyBJtCMipuagFVjD0z0beDpzXDsYWsbR-tQ',
//   libraries:        GOOGLE_MAPS_LIBRARIES,
//   language:         'en',
//   region:           'US',
// };

const GOOGLE_MAPS_OPTIONS = {
  id: 'google-maps-shared',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
  language: 'en',
  region: 'US',
};


/**
 * Shared Google Maps SDK loader.
 * Returns the same { isLoaded, loadError } as useJsApiLoader.
 * Safe to call in as many components as you like — the SDK loads only once.
 */
export function useGoogleMaps() {
  return useJsApiLoader(GOOGLE_MAPS_OPTIONS);
}